import React from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import dayjs from "dayjs";

function ExportExcel(props) {
    const { filename, companiesDataSet } = props;

    const [data, setData] = React.useState({});

    const exporter = React.useRef();

    const exportExcelFunction = () => {
        if (exporter.current) {
            exporter.current.save();
        }
    };

    React.useEffect(() => {
        const temp = (companiesDataSet || []).reduce((acc, element) => {
            const data = { ...element };
            data.career = element.career === '-----' ? 'No definido' : element.career;
            data.phoneNumber = element.phoneNumber === '-----' ? 'No definido' : element.phoneNumber;
            data.lastLogin = element.lastLogin ? 'Sin registro' : dayjs(element.lastLogin).format("DD / MM / YYYY");
            data.lastApply = element.lastApply ? 'Sin registro' : dayjs(element.lastApply).format("DD / MM / YYYY");
            data.existCv = element.existCv ? 'Si' : 'No';
            acc.push(data);
            return acc;
        }, []);
        setData(temp);
    }, [companiesDataSet]);

    return (
        <>
            <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
                Exportar a Excel
            </button>
            <ExcelExport data={data} fileName={`${filename}.xlsx`} ref={exporter}>
                <ExcelExportColumn title="ID o Matricula" field="scholarID" />
                <ExcelExportColumn title="Nombre" field="names" />
                <ExcelExportColumn title="Apellidos" field="lastNames" />
                <ExcelExportColumn title="Correo electrónico" field="email" />
                <ExcelExportColumn title="Tipo de usuario" field="userType" />
                <ExcelExportColumn title="Campus / Sede" field="campusSegment" />
                <ExcelExportColumn title="Carrera" field="career" />
                <ExcelExportColumn title="Teléfono" field="phoneNumber" />
                <ExcelExportColumn title="Última fecha de conexión" field="lastLogin" />
                <ExcelExportColumn title="Última fecha de aplicación" field="lastApply" />
                <ExcelExportColumn title="Cantidad de postulaciones" field="applyCount" />
                <ExcelExportColumn title="CV agregado" field="existCv" />
            </ExcelExport>
        </>
    );
}

export default ExportExcel;
